module.exports = __webpack_public_path__ + "img/Group 964t3.0e0f5050.svg";